const { default: axios } = require("axios");
const Cookies = require('js-cookie');
const VisitData = require('../vendor/visitdata');

const FormAjax = function () {

    const formAjax = function (e) {

        const form = $(this);
        const cookies = getCookies();
        let values = form.serialize();
        jQuery.each(cookies, function (key, value) {
            values += "&" + key + "=" + value;
        });
        const button = form.find('button');

        console.log(values);

        button.attr('disabled', 'disabled');
        form.find('button[type=submit] p').text('Enviando...');   

        axios.post(form.attr('action'), values)
            .then(function (response) {
                const data = response.data;

/*                 if (data.error == false) {
                    form.prepend('<div class="alert alert-success w-100" role="success"><p>' + data.message + '</p></div>');
                }else{
                    form.prepend('<div class="alert alert-danger w-100" role="alert"><p>' + data.message + '</p></div>');
                } */

                    Swal.fire({
                        icon: "success",
                        title: data.message,
                        showConfirmButton: false,
                        timer: 3000
                    });

                //event AW
                /* gtag('event', 'conversion', {
                    'send_to': 'AW-11301069027/LyPxCO7mu-UYEOPB4owq'
                });

                console.log('send_to : AW-11301069027/LyPxCO7mu-UYEOPB4owq'); */
                console.log('send_to : success');

                
                setTimeout(() => {
                    /* form.find('.alert').slideToggle('slow', function(){
                        $(this).remove();
                    }); */
                    $("#modal-ajax").removeClass('fixed').fadeOut(300);  
                }, 5000);

                /* setTimeout(() => {
                    $('html,body').animate({scrollTop: ( $("#form-access").offset().top - $('#header').outerHeight())});
                },800) */

                button.removeAttr('disabled');
                form.find('button[type=submit] p').text('Enviar');               
                $(form)[0].reset();                
            });

        e.preventDefault();
    }

    // PART OF INTEGRATION JS
    const setCookieByURL = function () {
        const search = window.location.search;
        const visitData = VisitData.get();
        const visitDataRaw = VisitData.rawData();

        //console.log(search);

        // deleteCookies();
        // if (window.location.host == visitData.source && visitData.medium == 'referral') {
        //     return false;
        // }

        if (Cookies.get('utm_source') !== undefined) {
            return false;
        }

        if (search.length == 0) {
            setArrayCookie(visitData, visitDataRaw.this_domain);
        } else {

            let queryString = search.replace("?", "");
            queryString = queryString.split("&");

            if (visitDataRaw.referral_data !== undefined) {
                if (visitDataRaw.referral_data !== null) {
                    setArrayCookie(visitDataRaw.referral_data, visitDataRaw.this_domain);
                } else {
                    Cookies.set("utm_source", "direct", { expires: 7, domain: "." + visitDataRaw.this_domain });
                }
            }

            jQuery.each(queryString, function (key, param) {
                if (param.indexOf("utm_") >= 0) {
                    let cookie = param.split("=");
                    Cookies.set(cookie[0], cookie[1], { expires: 7, domain: "." + visitDataRaw.this_domain });
                }
            });
        }

         //console.log(getCookies());
    }

    const setArrayCookie = function (arraCookie, domain) {
        jQuery.each(arraCookie, function (key, cookie) {
            let cookieName = "utm_" + key;
            let cookieValue = cookie;

            cookieValue = cookieValue.replace("(", "");
            cookieValue = cookieValue.replace(")", "");

            if (cookieValue != 'none' && cookieValue != 'not set') {
                Cookies.set(cookieName, cookieValue, { expires: 7, domain: "." + domain });
            }
        });
    }

    /* const getData = function (element) {
        const cookies = getCookies();
        let data = element.serialize();

        jQuery.each(cookies, function (key, value) {
            data += "&" + key + "=" + value;
        });

        return data;
    } */

    const getCookies = function () {
        const cookies = Cookies.get();

        let response = {};
        jQuery.each(cookies, function (key, cookie) {
            if (key.indexOf("utm_") >= 0) {
                response[key] = cookie;
            }
        });

        return response;
    }

    const deleteCookies = function () {
        const cookies = Cookies.get();
        jQuery.each(cookies, function (key, cookie) {
            if (key.indexOf("utm_") >= 0) {
                Cookies.remove(key)
            }
        });
    }

    // newsletter
    const formAjaxNews = function (e) {

        const form = $(this);
        let values = form.serialize();
        const button = form.find('button');

        button.attr('disabled', 'disabled');
        form.find('button[type=submit] p').text('Enviando...');   

        axios.post(form.attr('action'), values)
            .then(function (response) {

                // console.log(response);
                const data = response.data;

/*                 if (data.error == false) {
                    form.prepend('<div class="alert alert-success w-100" role="success"><p>' + data.message + '</p></div>');
                }else{
                    form.prepend('<div class="alert alert-danger w-100" role="alert"><p>' + data.message + '</p></div>');
                } */

                    Swal.fire({
                        icon: "success",
                        title: data.message,
                        showConfirmButton: false,
                        timer: 3000
                    });

                console.log('send_to : success');

                button.removeAttr('disabled');
                form.find('button[type=submit] p').text('Enviar');               
                $(form)[0].reset();                
            });

        e.preventDefault();
    }

    return {
        init: function () {

            setCookieByURL();
            $(document).on('submit', '.form-ajax', formAjax);
            $(document).on('submit', '.form-ajax-news', formAjaxNews);
        }
    }
}();

module.exports = FormAjax;